import gsap from 'gsap';
import { AnimationMixer } from 'three';

function getParentPartName(name) {
  let parent = name.split('_');
  parent = parent.splice(1, parent.indexOf('Global') - 1);
  parent = parent.join('_') + '-Global';

  this.ptl = new Map();
  this.rtl = new Map();

  return parent;
}

/* *** REVERT *** */

function revertParts() {
  this.additionnalParts.forEach((e, i) => {
    e.forEach((p) => {
      this.addPart(i, p);
    });
  });
}

/* *** ADD *** */

function addParts(...parts) {
  parts.forEach((id) => {
    const part = this.app.core.loader.getModel(id);
    if (part.children.length == 0) return;

    const name = part.children[0].name;
    let parent = this.getParentPartName(name);

    this.addPart(parent, part);
  });
}

function addPart(parent, model) {
  let ref = this.subObjectsMap.get(parent);

  if (model == null || parent == null || ref == null) return;

  model.children[0].position.set(0, 0, 0);
  model.children[0].rotation.set(0, 0, 0);
  model.children[0].scale.set(1, 1, 1);

  if (model.animations?.length) {
    model.mixer = new AnimationMixer(model);
    this.mixers.add(model.mixer);

    const actions = this.updateAnimations(model, model.mixer);
    Object.values(actions).forEach((action) => {
      action.play();
      action.enabled = true;
      action.weight = 1;
    });

    model.actions = actions;
  }

  if (!this.additionnalParts.has(parent)) this.additionnalParts.set(parent, []);
  this.additionnalParts.get(parent).push(model);

  this.mergeMaterials(model, this.commonArmorUniforms, false, false);

  ref.add(model);
}

/* *** UPDATE *** */

function updatePart(part) {
  const model = part;
  const name = model.children[0].name;

  let parent = this.getParentPartName(name);

  if (this.ptl.has(name)) this.ptl.get(name)?.kill?.();
  this.ptl.set(name, gsap.timeline());
  const tl = this.ptl.get(name);

  if (this.additionnalParts.has(parent))
    tl.add(this.removeParts(this.additionnalParts.get(parent)));

  const uVisiblity2 = { value: 0 };
  tl.add(() => {
    this.addPart(parent, model);

    model.traverse((e) => {
      if (e.isMesh) e.material.uniforms.uVisiblity2 = uVisiblity2;
    });
  });

  tl.to(uVisiblity2, { value: 1 });
}

/* *** REMOVE *** */

function removePartFromName(name) {
  const parentName = name + '-Global';
  if (this.additionnalParts.has(parentName))
    this.removeParts(this.additionnalParts.get(parentName));
}

function removeParts(objects = []) {
  objects.forEach((o) => {
    this.removePart(o);
  });
}

function removePart(object) {
  if (object.parent) {
    const name = object.children[0].name;

    if (this.rtl.has(name)) this.rtl.get(name)?.kill?.();
    this.rtl.set(name, gsap.timeline());
    const tl = this.rtl.get(name);

    if (object.mixer) this.mixers.delete(object.mixer);
    this.additionnalParts.delete(object.parent.name);

    const toHide = [];
    object.traverse((e) => {
      if (e.isMesh) toHide.push(e.material.uniforms.uVisiblity2);
    });

    tl.to(toHide, { value: 0 });

    tl.add(() => {
      object.parent.remove(object);

      object.traverse((e) => {
        if (e.isMesh) {
          e.material.uniforms.tMap.value.dispose();
          e.material.uniforms.tEmissiveMap?.value?.dispose();
          e.material.dispose();
          e.geometry.dispose();
        }
      });
    });
  }
}

export {
  getParentPartName,
  revertParts,
  updatePart,
  addParts,
  removePartFromName,
  removePart,
  removeParts,
  addPart,
};
